// 挂载在vue全局属性的方法和属性
export const isTrue = function (value) {
  function typeOf(value) {
    const v = Object.prototype.toString.call(value).slice(8, -1).toLowerCase()
    return v
  }
  if (!value) {
    return false
  }
  if (typeOf(value) === 'array') {
    if (value.length > 0) {
      return true
    } else {
      return false
    }
  } else if (typeOf(value) === 'object') {
    for (var key in value) {
      return true
    }
    return false
  } else {
    return true
  }
}

export const openNewWeb = function (router, routerName, query) {
  let routeData = router.resolve({
    name: routerName,
    query,
  })
  console.debug(routeData)
  window.open(routeData.href, '_blank')
}

export const pageJump = function (router, routerName, query, params) {
  // let url = window.location.href //获取url中"?"符后的字串
  // let newQuery = {}
  // if (url.indexOf('?') > -1) {
  //   let str = url.substring(url.indexOf('?') - 0 + 1)
  //   const strs = str.split('&')
  //   for (let i = 0; i < strs.length; i++) {
  //     newQuery[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1])
  //   }
  // }
  // console.debug(
  //   `pageJump: ${routerName}, query: ${JSON.stringify(
  //     query
  //   )}, newQuery: ${JSON.stringify(newQuery)}`
  // )
  // const VUE_APP_H5URL = process.env.VUE_APP_H5URL
  // if (routerName === 'platfromHomeIndex') {
  //   // 当切换赛事时mixtmt_platfromV4_currSportsDetail中的id可能在另外的赛事不存在，所以清除
  //   // 但是支持多个赛事同时在一个浏览器多个页签打开，这个删除要去掉，否则综合性赛事页签重新刷新找到不到这个缓存对象
  //   this.$localStorage.removeItem('mixtmt_platfromV4_currSportsDetail')
  // }
  let pushObj
  if (query) {
    pushObj = {
      name: routerName,
      // path: url
      query: query,
      params: params ? params : {},
      replace: true,
    }
  } else {
    pushObj = {
      name: routerName,
    }
  }
  router.push(pushObj)
  // router.push(Object.assign({}, pushObj, replace ? { replace: true } : {}))
}

export const pageReplaceJump = function (router, routerName, query, params) {
  // let url = window.location.href //获取url中"?"符后的字串
  // let newQuery = {}
  // if (url.indexOf('?') > -1) {
  //   let str = url.substring(url.indexOf('?') - 0 + 1)
  //   const strs = str.split('&')
  //   for (let i = 0; i < strs.length; i++) {
  //     newQuery[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1])
  //   }
  // }
  // console.debug(
  //   `pageJump: ${routerName}, query: ${JSON.stringify(
  //     query
  //   )}, newQuery: ${JSON.stringify(newQuery)}`
  // )
  // const VUE_APP_H5URL = process.env.VUE_APP_H5URL
  // if (routerName === 'platfromHomeIndex') {
  //   // 当切换赛事时mixtmt_platfromV4_currSportsDetail中的id可能在另外的赛事不存在，所以清除
  //   // 但是支持多个赛事同时在一个浏览器多个页签打开，这个删除要去掉，否则综合性赛事页签重新刷新找到不到这个缓存对象
  //   this.$localStorage.removeItem('mixtmt_platfromV4_currSportsDetail')
  // }
  let pushObj
  if (query) {
    pushObj = {
      name: routerName,
      // path: url
      query: query,
      params: params ? params : {},
      replace: true,
    }
  } else {
    pushObj = {
      name: routerName,
    }
  }
  router.replace(pushObj)
}
